import { useAccount } from "wagmi";
import DonationHistoryBanner from "../../../assets/DonationHistoryBanner";
import { truncateAddress } from "../utils/address";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function UnknownOrNoContributions(_ref) {
  let {
    address,
    ensName
  } = _ref;
  const {
    address: walletAddress
  } = useAccount();
  const partialAddress = truncateAddress(address);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex justify-center",
      children: /*#__PURE__*/_jsxs("div", {
        className: "w-3/4 my-6 text-center mx-auto",
        children: [address === walletAddress ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("p", {
            className: "text-md",
            children: "This is your donation history page, where you can keep track of all the public goods you've funded."
          }), /*#__PURE__*/_jsx("p", {
            className: "text-md",
            children: "As you make donations, your transaction history will appear here."
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("p", {
            className: "text-md",
            children: `This is ${ensName || partialAddress}’s donation history page, showcasing their contributions
              towards public goods.`
          }), /*#__PURE__*/_jsx("p", {
            className: "text-md",
            children: "As they make donations, their transaction history will appear here."
          })]
        }), /*#__PURE__*/_jsx("div", {})]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "flex justify-center",
      children: /*#__PURE__*/_jsx(DonationHistoryBanner, {
        className: "w-full h-auto object-cover rounded-t"
      })
    })]
  });
}